// extracted by mini-css-extract-plugin
module.exports = {"bg":"Day_bg__2D11b","heading":"Day_heading__198p9","img":"Day_img__1WnO3"};